import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {DataSourcesListingState} from './data-sources-listing';
import {AppState} from '../store';
import {Store} from '@ngrx/store';
import {Observable, withLatestFrom} from 'rxjs';
import {Serializer} from '../../interfaces/serializer';
import {Site} from '../../interfaces/site';
import {selectSite} from '../init/init.selectors';
import {DataSource} from '../../interfaces/data-source';
import {tap} from 'rxjs/operators';
import {TrendsDialogComponent} from '../../components/trends-dialog/trends-dialog.component';
import {dialogOpen} from '../dialog/dialog.actions';
import {selectMetricComponentObjects} from "../selectors";
import {MetricComponentObject, MetricComponentObjects} from "../../classes/metric-component-object";

@Injectable()
export class DataSourcesListingStore extends ComponentStore<DataSourcesListingState> {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);

  public readonly openTrends: (dataSource: Serializer<DataSource>) => void = this.effect((datasource$: Observable<Serializer<DataSource>>): Observable<[Serializer<DataSource>, Serializer<Site>, MetricComponentObjects]> => datasource$.pipe(
    withLatestFrom(this._dataset$, this._store.select(selectMetricComponentObjects)),
    tap(([dataSource, dataset, metrics]: [Serializer<DataSource>, Serializer<Site>, MetricComponentObjects]): void => {
      this._store.dispatch(dialogOpen({
        component: TrendsDialogComponent,
        config: {
          width: '1000px',
          height: 'auto'
        },
        data: {
          dataset: dataset,
          colDef: {
            headerName: dataSource.attributes.last_imported.metric_slug,
            params: {
              action: 'value',
              metric: metrics.find((metric: MetricComponentObject): boolean => metric.payload.attributes.slug === dataSource.attributes.last_imported.metric_slug)
            }
          },
          value: {
            slug: dataSource.attributes.last_imported.metric_slug,
            row: {
              dimensions: {
                'usage-id': {
                  slug: 'usage-id',
                  value: dataSource.id
                }
              }
            }
          },
          params: {
            period: { type: 'last_30_days' }
          }
        }
      }));
    })
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({});
  }



}
